import styled from "styled-components";
import { SPACING, ANIMATION } from "../../../utils/constants";

export const Container = styled.div`
  margin-top: ${SPACING.sm + SPACING.xs}px;
  padding: ${SPACING.sm + SPACING.xs}px;
  background: var(--color-background-2);
  border: 1px solid var(--color-border);
  border-radius: 0.5rem;
`;

export const MeterContainer = styled.div`
  margin-bottom: ${SPACING.sm + SPACING.xs}px;
`;

export const MeterLabel = styled.div<{ strength: number; color: string }>`
  font-size: var(--text-xs);
  font-weight: 600;
  color: ${(props) => props.color || "var(--color-text-secondary)"};
  margin-bottom: ${SPACING.xs + SPACING.xxs}px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const MeterBar = styled.div`
  width: 100%;
  height: 6px;
  background: var(--color-background-0);
  border-radius: 3px;
  overflow: hidden;
`;

export const MeterFill = styled.div<{ strength: number; color: string }>`
  height: 100%;
  width: ${(props) => props.strength}%;
  background: ${(props) => props.color};
  transition:
    width ${ANIMATION.duration.moderate} ${ANIMATION.easing.easeOut},
    background ${ANIMATION.duration.moderate} ${ANIMATION.easing.easeOut};
  border-radius: 3px;
`;

export const RequirementsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs + SPACING.xxs}px;
`;

export const RequirementItem = styled.li<{ $isMet: boolean }>`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm}px;
  font-size: var(--text-xs);
  color: ${(props) =>
    props.$isMet ? "var(--color-text-default)" : "var(--color-text-secondary)"};
  font-weight: ${(props) => (props.$isMet ? "500" : "400")};

  span {
    line-height: 1.4;
  }
`;
